// extracted by mini-css-extract-plugin
export var brand = "_31-9";
export var button = "_31-0";
export var chevron = "_31-v";
export var chevronButton = "_31-w";
export var content = "_31-n";
export var danger = "_31-g";
export var dangerOutlined = "_31-h";
export var dark = "_31-l";
export var darkTheme = "_31-c";
export var extraSmall = "_31-4";
export var fullWidth = "_31-8";
export var ghost = "_31-d";
export var gray = "_31-t";
export var icon = "_31-p";
export var iconButton = "_31-s";
export var iconButtonBorder = "_31-x";
export var iconButtonBorderDark = "_31-y";
export var iconButtonBorderLight = "_31-z";
export var iconLeft = "_31-q";
export var iconRight = "_31-r";
export var large = "_31-1";
export var light = "_31-m";
export var medium = "_31-2";
export var micro = "_31-5";
export var nano = "_31-7";
export var outlined = "_31-k";
export var pending = "_31-a";
export var primary = "_31-i";
export var shadow = "_31-o";
export var small = "_31-3";
export var solidLight = "_31-e";
export var solidLightBrand = "_31-f";
export var spinner = "_31-u";
export var transparent = "_31-j";
export var warning = "_31-b";
export var wideNano = "_31-6";